import classnames from 'classnames';

import {BoltRegularIcon} from 'shells/icon/svg/bolt-regular-icon';

import {getIconSize} from './sidebar';
import {SidebarIcon} from './sidebar-icon';
import {SidebarNavLink} from './sidebar-nav-link';

type Props = {
    activeTab: string;
    basePath: string;
    isMainSidebarCollapsed: boolean;
    shouldShowExploreAttentionBadge: boolean | null | undefined;
};

export function ExploreNavItem(props: Props) {
    const attentionBadgeClassName = classnames(
        'nut-sidebar--notification-badge--new nut-sidebar--notification-badge--explore',
        {
            collapsed: props.isMainSidebarCollapsed,
        }
    );

    return (
        <SidebarNavLink
            isActive={props.activeTab === 'explore'}
            intercomKey='explore'
            onBasePath={props.basePath === 'explore'}
            href='/explore'
            to='/explore'
            tooltipText={props.isMainSidebarCollapsed ? 'Explore' : undefined}
        >
            <SidebarIcon icon={BoltRegularIcon} size={getIconSize('explore')} label={'Explore'} />
            {props.shouldShowExploreAttentionBadge && (
                <span className={attentionBadgeClassName}></span>
            )}
        </SidebarNavLink>
    );
}
